<template>
  <v-container fluid class="my-5">
    <MesaDirectivaDashboard />
  </v-container>
</template>

<script>
import MesaDirectivaDashboard from '@/components/mesaDirectiva/MesaDirectivaDashboard.vue'

export default {
  name: 'mesa_directiva_dashboard',
  components: {
    MesaDirectivaDashboard
  }
}
</script>
